export class OrganismeEdition {
    static jsonMap = {
        id: { key: 'id', optional: true },
        raisonSociale: { key: 'raisonSociale', optional: true, default: '' },
        adresse: { key: 'adresse', optional: true, default: '' },
        codePostal: { key: 'codePostal', optional: true, default: '' },
        ville: { key: 'ville', optional: true, default: '' },
        mail: { key: 'mail', optional: true, default: '' },
        telephone: { key: 'telephone', optional: true, default: '' },
        logo: { key: 'logo', optional: true, default: '' }
    };

    id: number;
    raisonSociale: string;
    adresse: string;
    codePostal: string;
    ville: string;
    mail: string;
    telephone: string;
    logo: string;
}
